import { createI18nextIntegration } from '@withease/i18next';
import { createEvent } from 'effector';
import { i18next } from '../i18next';

const setup = createEvent();

export const { $t, $language, changeLanguageFx, translated } = createI18nextIntegration({
	instance: i18next,
	setup,
});

export const translations = {
	setup,
	$t,
	$language,
	changeLanguageFx,
	translated,
};
